import React, { useContext } from 'react'
import { CartContext } from '../Contexts/CartContext';
import { IoCart } from 'react-icons/io5';

const Product = ({ mangoe, openCustomPopup }) => {
  const { addToCart } = useContext(CartContext)

  return (
    <>
      <div className="box">
          <div className="img">
              <img src={mangoe.image_url} alt="Mangues" />
          </div>
          <div className="text">
            <h3>{mangoe.variety}</h3>
            <p>
              {mangoe.description}
            </p>
            <div className="price">2,5€/Kg</div>

          </div>
          <button onClick={() => openCustomPopup(mangoe)}>
            <span className="mob"><span className="icon"><IoCart /></span> Ajouter au panier</span>
            <span className="desk"><span className="icon"><IoCart /></span> Ajouter</span>
          </button>
      </div>
    </>
  )
}

export default Product